export interface CustomerDetails {
  id: string;
  key: string;
  name: string;
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  townCity: string;
  region: string;
  postCode: string;
  countryId: string;
  tel: string;
  fax: string;
  email: string;
  web: string;
  vatRegNo: string;
  obsolete: boolean;
  companyRegNo: string;
  intraEcVatNo: string;
  certificationRequired: boolean;
  accountCode: string;
  testReportRequired: boolean;
  emailConfirmation: boolean;
  emailDespatchNote: boolean;
  emailInvoice: boolean;
  internal: boolean;
  crmAccountCode: string;
  confirmationEmailAddress: string;
  despatchNoteEmailAddress: string;
  invoiceEmailAddress: string;
  mobileNo: string;
  sellingCompanyId: string;
  creditLimit: number;
  currencyId: string;
  bankId: string;
  taxId: string;
  paymentTermId: string;
  creditCheck: boolean;
}
